module.exports = __webpack_public_path__ + "img/menu2.6bed2291.png";